import script from "./MenuItemFolderDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemFolderDropdown.vue?vue&type=script&setup=true&lang=js"

import "./MenuItemFolderDropdown.vue?vue&type=style&index=0&id=26506328&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26506328"]])

export default __exports__